module.exports = __webpack_public_path__ + "static/media/loading.f452f976.gif";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Search/img/loading.gif
// module id = 583
// module chunks = 0